import React, {useMemo, useState} from 'react';

import CloudOffIcon from "@material-ui/icons/CheckCircle";
import { LibraryItem } from '../../entities/LibraryItem';

import { useOfflineAssets } from '../offline/useOfflineAssets';
import { LibraryItemType } from '../../entities/LibraryItemType';
import { Grid, Typography } from '@material-ui/core';
import { GridGrow } from '../../components/GridGrow';
import { VerticalCenter } from '../../components/VerticalCenter';
import { SortByDropDown, SortCatagories } from './Views/Components/SortByDropDown';
import { useIsMobile } from '../../components/Mui3WidthProvider';
import { RightSideInteractions } from './LibraryAssetActions/RightSideInteractions';
import { DesktopLibraryAssetTable } from './Views/Components/DesktopLibraryAssetTable';
import { RightDrawer } from './RightDrawer/RightDrawer';
import { HorizontalCentered } from '../../components/HorizontalCentered';
import { MobileLibraryAssetTable } from './Views/Components/MobileLibraryAssetTable';
import { PageTitle } from '../../components/PageTitle';

interface Props {
}

export function LibraryOffline(props:Props) {
    const [sortBy, setSortBy] = useState<SortCatagories>("Last Modified");
    const isMobile = useIsMobile();

    const offlineAssets = useOfflineAssets();
    const libraryItems = useMemo(() => offlineAssets.offlineBuilderAssets.map<LibraryItem>(a => ({...a, type: LibraryItemType.BuilderAsset })), [offlineAssets.offlineBuilderAssets]);

    const [focusedItemId, setFocusedItemId] = useState<string>();
    const focusedItem = useMemo(() => libraryItems.find(i => i.id === focusedItemId), [focusedItemId, libraryItems])

    return (
        <>
        <PageTitle title="Sermon Maker - Offline Access"/>
        { isMobile 
        ?
            <MobileLibraryAssetTable 
                items={libraryItems}
                focusedItem={focusedItem}
                setFocusedItemId={(id) => setFocusedItemId(id)}
            />
        :
            <div style={{height: "100%"}}>
                <Grid container style={{height: 45, borderBottom: "1px solid rgb(225, 225, 225)"}}>
                    <Grid container item md={8} lg={9}  alignItems="center">
                        <Grid item>
                            <Typography style={{ color: "#5f6368", fontSize: "18px", fontWeight: 500, fontFamily: "Roboto, Helvetica"}}>
                                Offline Enabled
                            </Typography>
                        </Grid>
                        <GridGrow />
                        <Grid item>
                            <SortByDropDown
                                sortBy={sortBy}
                                sortPremiumContent={false}
                                handleSortByChange={(sort) => setSortBy(sort)}
                            />
                        </Grid>
                    </Grid>
                    <Grid container item md={4} lg={3} >
                        <GridGrow />
                        <Grid item>
                            <RightSideInteractions focusedItem={focusedItem} />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid container style={{height: "calc(100% - 45px)"}}>
                    <Grid item md={8} lg={9} style={{height: "100%", overflowY: "auto"}}>
                    {libraryItems.length === 0
                    ?
                        <VerticalCenter>
                            <HorizontalCentered>
                                <HorizontalCentered>
                                    <CloudOffIcon style={{ width: "150px", height: "150px", color: "#CCC"}}/>
                                </HorizontalCentered>
                                <Typography 
                                    style={{ 
                                        fontFamily: "Roboto, Helvetica", fontSize: "12px", marginTop: "12px", color: "#5f6368"
                                }}
                                >Enable documents for offline availability within the sermon editor</Typography>
                            </HorizontalCentered>
                        </VerticalCenter>
                    :
                        <DesktopLibraryAssetTable items={libraryItems} sortBy={sortBy} setFocusedItem={(id) => setFocusedItemId(id)} focusedItem={focusedItem} />
                    }
                    </Grid>
                    <Grid item md={4} lg={3} style={{height: "100%", borderLeft: "1px solid rgb(225, 225, 225)"}}>
                        <RightDrawer item={focusedItem} />
                    </Grid>
                </Grid>
            </div>
        }
        </>
    );
}